import FeedThumb from './FeedThumb';
import FeedThumbContainer from './FeedThumb.container';
export default FeedThumbContainer(FeedThumb);
